import NewEmployeePanelContainer from "./newEmployeePanel.container";

export default NewEmployeePanelContainer;